export default "__VITE_ASSET__7a57503e__"